module.exports = __webpack_public_path__ + "assets/e576e924b0d77e79d846f43740764a5c.png";